export const toLowercase = <T extends string>(value: T): Lowercase<T> => {
  return value.toLowerCase() as Lowercase<T>;
};
